export const isDigitsKey = (key: string): boolean => /^\d$/.test(key);

export const sanitizeDigits = (value: string): string => {
  return value.replace(/\D/g, '');
};

export const generateEmpty = (length: number): string => ' '.repeat(length);

export const isValid = (code: string, length: number): boolean => {
  const stripped = code.replace(/\s/g, '');
  return stripped.length === length && /^\d+$/.test(stripped);
};
